<template>
  <b-row>
    <b-col cols="12" class="mb-1">
      <h3 class="mb-0">
        รายละเอียดการร้องทุกข์
      </h3>
    </b-col>

    <div
      v-for="value in complaintDetail"
      :key="value.description"
      class="col-12"
    >
      <div class="mt-2">
        <h4 class="">
          {{ value.description }}
          <small class="text-danger text-small">
            **โปรดระบุข้อมูลอย่างน้อย 1 รายการ</small
          >
        </h4>

        <div v-if="value.masterTypeId == 6">
          <b-row>
            <b-col
              v-for="(header, index) in complaintDetail[0].tmMasterList"
              :key="index"
              cols="12"
            >
              <div v-if="header.checked == true" class="mt-1">
                <div>-หมวดหมู่เรื่องร้องทุกข์ {{ header.description }}</div>
                <b-row>
                  <b-col
                    v-for="(box, index) in value.tmMasterList.filter((obj) => {
                      return obj.refMasterId === header.masterId;
                    })"
                    :key="index"
                    cols="4"
                    class="mt-1"
                  >
                    <b-form-checkbox
                      :disabled="IsReadOnly"
                      :key="index"
                      v-model="box.checked"
                      @change="checkboxChanged(box)"
                    >
                      {{ box.description }}
                    </b-form-checkbox>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </div>

        <div v-else>
          <b-row>
            <b-col
              v-for="(box, index) in value.tmMasterList"
              :key="index"
              cols="4"
              class="mt-1"
            >
              <b-form-checkbox
                :disabled="IsReadOnly"
                :key="index"
                v-model="box.checked"
                @change="checkboxChanged(box)"
              >
                {{ box.description }}
              </b-form-checkbox>
            </b-col>
          </b-row>
        </div>
        <b-col cols="12">
          <hr />
        </b-col>
      </div>
    </div>

    <!-- {{ complaintDetailMultiSelect }} -->
    <div
      v-for="value in complaintDetailMultiSelect"
      :key="value.description"
      class="col-12"
    >
      <div class="mt-2">
        <h4 class="">
          {{ value.description }}
          <small class="text-danger text-small">
            **โปรดระบุข้อมูลอย่างน้อย 1 รายการ</small
          >
        </h4>

        <!-- multiselect -->
        <b-row>
          <!--v-if="value.tmMasterList != null"  handle ตอนโหลดข้อมูล-->
          <b-col v-if="value.tmMasterList != null" cols="12" class="mt-1">
            <multiselect
              :disabled="IsReadOnly"
              v-model="value.tmMasterListSelected"
              track-by="description"
              label="description"
              :options="value.tmMasterList"
              :multiple="true"
              @select="onMasterSelected"
            >
            </multiselect>
          </b-col>
        </b-row>

        <!-- {{ value.tmMasterList }} -->
        <!-- amount -->
        <b-row v-if="value.tmMasterListSelected !== null">
          <b-col
            cols="6"
            class="mt-1"
            v-for="item in value.tmMasterListSelected.filter(
              (f) => f.masterId === 498 || f.masterId === 499
            )"
            :key="item.masterId"
          >
            <span>
              {{ item.description + " (บาท) " }}
              <small class="text-danger text-small">
                **โปรดระบุจำนวนเงินเป็นตัวเลขเท่านั้น</small
              >
            </span>
            <b-form-input
              :id="`frmInputMaster_${item.masterId}`"
              v-model="item.amount"
              @input="
                onAmountChange(item.amount, `spanMaster_${item.masterId}`)
              "
              placeholder="กรุณาใส่จำนวนเงิน (บาท)"
              type="number"
              :disabled="IsReadOnly"
            />
            <span
              :ref="`spanMaster_${item.masterId}`"
              :id="`spanMaster_${item.masterId}`"
              class="mt-1 text-danger text-small"
            ></span>
            <!-- <ValidationProvider
              rules="required"
              :name="item.description"
              v-slot="{ errors }"
            >
              <b-form-input
                v-model="item.amount"
                @input="onAmountChange"
                placeholder="กรุณาใส่จำนวนเงิน (บาท)"
                type="number"
              />
              <span class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider> -->
            <!-- <Field
              :name="`masterName_${item.masterId}`"
              type="number"
              :rules="validateAmount"
              v-model="item.amount"
              @input="onAmountChange"
              placeholder="กรุณาใส่จำนวนเงิน (บาท)"
            />
            <ErrorMessage :name="`masterName_${item.masterId}`"></ErrorMessage> -->
          </b-col>
        </b-row>

        <b-row
          v-for="value2 in complaintCatagoryDetail"
          :key="value2.catagoryDeId + value2.masterTypeId"
        >
          <b-col
            v-if="value.masterTypeId == value2.masterTypeId"
            cols="12"
            class="mt-1"
          >
            <b-form-group label="รายละเอียดเพิ่มเติม">
              <b-form-input
                v-model="value2.description"
                :value="value2.description"
                :disabled="IsReadOnly"
                class="col-12"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-col cols="12">
          <hr />
        </b-col>
      </div>
    </div>

    <div class="col-12" v-if="mouCompanies != null && mouCompanies.length > 0">
      <b-row>
        <b-col cols="12">
          <h3 class="mb-0">
            เข้าร่วม FastTrack
          </h3>
        </b-col>
        <b-col cols="12" class="mt-1 mb-1">
          <b-form-group label="ต้องการเข้าร่วม Fasttrack หรือไม่?">
            <b-form-radio-group
              v-model="needFastTrack"
              @change="onNeedFastTrackChange"
              aria-controls="ex-disabled-readonly"
            >
              <b-form-radio :value="true">
                ต้องการ
              </b-form-radio>
              <b-form-radio :value="false">
                ไม่ต้องการ
              </b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>

        <b-row class="col-12 mb-2" v-if="needFastTrack">
          <b-col cols="6">
            <label>
              <span>เลือกผู้ประกอบการที่ส่งข้อมูล Fastrack</span
              ><small class="text-danger text-small">
                **โปรดเลือกผู้ประกอบ</small
              ></label
            >
            <multiselect
              :disabled="IsReadOnly"
              v-model="selectedCompanyMOU"
              track-by="companyDetail"
              label="companyDetail"
              :options="mouCompanies"
              :multiple="false"
              @select="onMouCompanySelected"
            >
            </multiselect>
          </b-col>
          <b-col cols="6">
            <label>
              <span>หมายเลขคำสั่งซื้อ</span
              ><small class="text-danger text-small">
                **โปรดระบุหมายเลขคำสั่งซื้อ</small
              ></label
            >
            <b-form-input
              v-model="selectedCompanyMOU.purchaseNo"
              :value="selectedCompanyMOU.purchaseNo"
              @input="emitSelectedCompanyMOU"
              :disabled="IsReadOnly"
              class="col-12"
            />
          </b-col>
          <b-col cols="12">
            <label for="file-input-purchase-order" class="mt-1"
              >แนบไฟล์รายละเอียดคำสั่งซื้อ (ถ้ามี)</label
            >
            <!-- file type = 823  -->
            <b-overlay :show="file1Overlay" rounded="sm">
              <b-form-file
                @change="onUploadFileChangedType823"
                id="file-input-purchase-order"
                ref="file-input-purchase-order"
                multiple
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
              />
            </b-overlay>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="mb-1">
            <h3 class="mb-0">
              หลักฐานประกอบการร้องทุกข์
            </h3>
          </b-col>
          <b-row
            v-for="file in this.attachFiles"
            :key="file.attachId"
            class="col-12 m-1"
          >
            <b-col cols="5">
              <a
                :href="file.filePath"
                :download="file.fileName"
                target="_blank"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="feather feather-arrow-down-circle"
                >
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="8 12 12 16 16 12" />
                  <line x1="12" y1="8" x2="12" y2="16" />
                </svg>
                {{ file.fileName }}
              </a>
            </b-col>
            <b-col cols="5" class="d-flex justify-content-center">
              {{ file.masterDescription }}
            </b-col>
            <b-col cols="1" class="d-flex justify-content-center">
              {{ file.downloadCount }}
            </b-col>
            <b-col cols="1" class="d-flex justify-content-center">
              <a
                href="#"
                class="text-danger"
                @click="emitDeleteFile(file.attachId)"
              >
                <feather-icon icon="Trash2Icon" size="24" />
              </a>
            </b-col>
          </b-row>
        </b-row>
      </b-row>
    </div>
  </b-row>
</template>

<script setup>
import { ref, watch } from "vue";
watch(
  () => props.complaintDetailMultiSelect,
  (before, after) => {
    console.log("@w", before, after);
  }
);
</script>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BForm,
  BButton,
  BCard,
  BFormTextarea,
  BFormCheckboxGroup,
  BFormCheckbox,
  BCardText,
  BFormRadioGroup,
  BFormRadio,
  BFormFile,
  BOverlay,
} from "bootstrap-vue";
// import { required, email } from '@validations'
import CustomSelectGroup from "./CustomSelectGroup.vue";
import CustomRadioGroup from "./CustomRadioGroup.vue";

import * as ComplaintAPI from "@/store/api/complaint/complaint.js";
import * as CompanyApi from "@/store/api/company/index.js";
import * as storeFileUpload from "@/store/api/fileUpload/index.js";
import * as userData from "@/auth/localStorageUtils.js";

import Multiselect from "vue-multiselect";

import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
// import { Form, Field, ErrorMessage } from "vee-validate";
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    // FormWizard,
    // TabContent,
    // Field,
    // ErrorMessage,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckboxGroup,
    BFormCheckbox,
    BCardText,
    BFormRadioGroup,
    BFormRadio,
    // vSelect,
    // BFormInvalidFeedback,
    // eslint-disable-next-line vue/no-unused-components
    // ToastificationContent,
    BForm,
    BButton,
    BCard,
    BFormTextarea,
    BFormFile,
    BOverlay,
    CustomSelectGroup,
    CustomRadioGroup,
    ComplaintAPI,
    Multiselect,
  },
  data() {
    return {
      //   selected: null,
      //   options: [
      //     { description: 'Vue.js', language: 'JavaScript' },
      //     { description: 'Rails', language: 'Ruby' },
      //     { description: 'Sinatra', language: 'Ruby' },
      //     { description: 'Laravel', language: 'PHP', $isDisabled: true },
      //     { description: 'Phoenix', language: 'Elixir' }
      //   ]
      file1Overlay: false,
      attachFiles: [],
    };
  },
  props: {
    // complaintSubjectSelects: {
    //   type: Array,
    // },
    // complaintTypeSelects: {
    //   type: Array,
    // },
    // complaintReasonSelects: {
    //   type: Array,
    // },
    // complaintPlaceSelects: {
    //   type: Array,
    // },
    // complaintMotivateSelects: {
    //   type: Array,
    // },
    // complaintPaymentMethodSelects: {
    //   type: Array,
    // },
    // complaintOnlineRadio: {
    //   type: Array,
    // },
    complaintCatagoryDetail: {
      type: Array,
      default: [],
    },
    IsReadOnly: Boolean,
    complaintDetail: {
      type: Array,
    },
    complaintDetailMultiSelect: {
      type: Array,
      default: [],
    },
    mouCompanies: [],
    needFastTrack: {
      type: Boolean,
      default: false,
    },
    selectedCompanyMOU: {
      type: Object,
      default: () => ({}),
    },
  },
  created() {
    // `this` points to the vm instance
    // console.log(`a is: ${this.a}`)
    // console.log('this complaintSubjectSelects', this.complaintSubjectSelects)
    //this.checkCompanyMOUByCompany(this.complainantCompany);
  },
  mounted() {
    //this.checkCompanyMOUByCompany(this.complainantCompany);
  },
  // watch: {
  //   complainantCompany: {
  //     immediate: true,
  //     deep: true,
  //     handler(val) {
  //       if (!val || val.length === 0) return;
  //       const ids = val.map((c) => c.compId).filter(Boolean);
  //       this.checkCompanyMOU(ids);
  //     },
  //   },
  // },

  methods: {
    checkboxChanged(obj) {
      //console.log("checkboxChangedIn: ", obj)
      console.log("multiselectedChanged: ", this.complaintDetailMultiSelect);
      this.$emit("checkboxChanged", obj);
    },
    multiselectedChanged(obj) {
      console.log("multiselectedChanged: ", obj);
    },
    refreshPage() {
      //call from root
      this.$forceUpdate();
    },
    onMasterSelected(e) {
      console.log("@e", e);
      // ต้องการเงินคืน:498, ต้องการเรียกร้องค่าเสียหาย:499
      if (e.masterId === 498 || e.masterId === 499) {
        console.log("@e props", this.complaintDetailMultiSelect);
      }
    },
    onAmountChange(e, el) {
      console.log("@e refs ", this.$refs);
      console.log("@e refs ", this.$refs[el][0]);

      if (e !== null && e !== undefined && e !== "") {
        console.log("@e amount ", e);
        if (e.includes("-")) {
          this.$refs[el][0].innerHTML = "กรุณาใส่จำนวนเงินมากกว่า 0";
        } else {
          this.$refs[el][0].innerHTML = "";
        }
      } else {
        console.log("@e no amount", e);
        this.$refs[el][0].innerHTML = "กรุณาใส่จำนวนเงิน";
      }
      this.$forceUpdate();
    },
    onNeedFastTrackChange(e) {
      this.$emit("onNeedFastTrackChanged", e);

      // ถ้าไม่ต้องการ FastTrack → clear ข้อมูล
      if (e === false) {
        this.selectedCompanyMOU = {};
        this.$emit("selectedCompanyMOUChanged", this.selectedCompanyMOU);
      }
    },
    onMouCompanySelected(e) {
      console.log("step3.vue onMouCompanySelected e", e);
      const updated = {
        ...e,
        attachFiles: this.attachFiles || [],
      };

      this.$emit("selectedCompanyMOUChanged", updated);
    },
    emitSelectedCompanyMOU(e) {
      console.log(
        "step3.vue emitSelectedCompanyMOU this.selectedCompanyMOU",
        this.selectedCompanyMOU
      );
      const updated = {
        ...(this.selectedCompanyMOU || {}),
        purchaseNo: e,
      };
      this.$emit("selectedCompanyMOUChanged", updated);
    },
    onUploadFileChangedType823(e) {
      // อัพโหลดหลายไฟล์ได้พร้อมกัน
      const selectedFiles = e.target.files;
      if (
        selectedFiles === null ||
        selectedFiles === undefined ||
        selectedFiles.length <= 0
      ) {
        return;
      }

      const _this = this;
      this.file1Overlay = true;

      var isMissing = this.onValidateExtensionFiles(selectedFiles, 823);

      if (isMissing === true) {
        this.file1Overlay = false;
        return;
      }

      selectedFiles.forEach(function(value, index) {
        // console.log("righttabaction.onuploadfilechangedtype3.value", value);
        _this.createBase64Image(value, 823);
      });
    },
    onValidateExtensionFiles(selectedFiles, section) {
      console.log(`righttabaction.onvalidateextensionfiles.section`, section);
      let isMissing = false;

      // เช็คว่าไฟล์ที่อัพโหลดมีสกุลไฟล์หรือไม่
      // ถ้าไม่มีให้แสดง popup แจ้งเตือน
      const arrNoExtension = Object.values(selectedFiles).filter((file) => {
        return (
          file.type === null || file.type === undefined || file.type === ""
        );
      });
      // console.log(
      //   "righttabaction.onvalidateextensionfiles.arrnoextension",
      //   arrNoExtension
      // );
      if (arrNoExtension.length > 0) {
        isMissing = true;
        this.$swal({
          html:
            "<div>ไม่สามารถอัพโหลดไฟล์ที่ไม่มีสกุลไฟล์ได้<br />กรุณาตรวจสอบไฟล์ของท่านก่อนทำการอัพโหลด</div>",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "ตกลง",
          customClass: {
            confirmButton: "btn btn-danger",
          },
        }).then((result) => {
          // console.log(
          //   "righttabaction.onvalidateextensionfiles.fileinput",
          //   this.$refs["file-input"]
          // );
          // console.log(
          //   "righttabaction.onvalidateextensionfiles.fileinput2",
          //   this.$refs["file-input2"]
          // );
          try {
            this.$refs["file-input-purchase-order"].reset();
          } catch (ex) {
            console.log(ex);
          }
        });
      }

      return isMissing;
    },
    createBase64Image(fileObject, type = null) {
      const _this = this;
      const reader = new FileReader();

      const fileName = fileObject.name;
      const fileSize = fileObject.size;

      reader.onload = (e) => {
        const fileBase64 = e.target.result;
        console.log(
          "fileName=",
          fileName,
          "fileSize=",
          fileSize,
          "fileType=",
          _this.selected,
          "Type=",
          type
        );

        try {
          this.$refs["file-input-purchase-order"].reset();
        } catch (ex) {
          console.log(ex);
        }

        const data = [
          {
            fileName: fileName,
            fileSize: fileSize,
            fileBase64: fileBase64,
            //keyId: this.complaintId,
            userId: userData.userId(),
            TypeUserUpload: type,
          },
        ];
        if (type == null) {
          storeFileUpload
            .uploadFile(data)
            .then(function(response) {
              // handle success
              console.log(response);
              response.data.data.forEach(function(value, index) {
                //console.log('emit upload', value)
                //this.$emit('handleSend', id)
                _this.emitUploadFile(value);
              });
            })
            .catch(function(error) {
              // handle error
              console.log("error", error);
            })
            .then(function() {
              // always executed
              _this.file1Overlay = false;
            });
        } else {
          storeFileUpload
            .uploadFileWithType(data)
            .then(function(response) {
              // handle success
              console.log(response);
              response.data.data.forEach(function(value, index) {
                //console.log('emit upload', value)
                //this.$emit('handleSend', id)
                _this.emitUploadFile(value);
              });
            })
            .catch(function(error) {
              // handle error
              console.log("error", error);
            })
            .then(function() {
              _this.file1Overlay = false;
            });
        }

        //console.log('base64', base64)
      };

      reader.readAsDataURL(fileObject);
    },
    emitUploadFile(file) {
      console.log("handleUpload");

      this.attachFiles.push(file);

      const updatedCompany = {
        ...(this.selectedCompanyMOU || {}),
        attachFiles: this.attachFiles,
      };
      // ส่งกลับ parent
      this.$emit("selectedCompanyMOUChanged", updatedCompany);
      //this.$emit('handle-upload', file)
    },
    emitDeleteFile(id) {
      console.log("emitDeleteFile", id);
      const _this = this;

      this.$swal({
        title: "ยืนยันการลบข้อมูล?",
        text: "",
        icon: "success",
        showCancelButton: true,
        confirmButtonText: "บันทึก",
        cancelButtonText: "ยกเลิก",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-primary ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          storeFileUpload
            .DeleteFile(id, userData.userId())
            .then(function(response) {
              // handle success
            })
            .catch(function(error) {
              // handle error
            })
            .then(function() {
              // always executed
            });

          const file = this.attachFiles.find(function(value) {
            return value.attachId === id;
          });

          var filteredAry = this.attachFiles.filter((o) => o.attachId != id);

          this.attachFiles = filteredAry;

          const updatedCompany = {
            ...(this.selectedCompanyMOU || {}),
            attachFiles: filteredAry,
          };

          this.$emit("selectedCompanyMOUChanged", updatedCompany);

          //this.$emit('handle-delete', id)
        }
      });
    },

    // async checkCompanyMOUByCompany(complainantCompany) {
    //   if (!complainantCompany || complainantCompany.length === 0) return;
    //   console.log("@complainantCompany1", complainantCompany);

    //   const companyIds = complainantCompany
    //     .map((c) => c.compId)
    //     .filter(Boolean);

    //   if (companyIds.length === 0) return;

    //   await CompanyApi.getCompanyMOU(companyIds).then((response) => {
    //     console.log("@companyMOU", response.data);
    //     const mouList = response.data.data || [];
    //     console.log("@mouList", mouList);
    //     console.log("@complainantCompany2", complainantCompany);
    //     this.mouCompanies = complainantCompany.filter((c) =>
    //       mouList.some(
    //         (m) =>
    //           m.isMou &&
    //           String(m.companyId).toLowerCase() ==
    //             String(c.compId).toLowerCase()
    //       )
    //     );
    //     console.log("@mouCompanies", this.mouCompanies);
    //   });
    // },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
